import CriticalIcon from '@/components/ruleStatusIcons/CriticalIcon';
import WarningIcon from '@/components/ruleStatusIcons/WarningIcon';
import {
    IconAdjustmentsAlt,
    IconArrowsDiff,
    IconCheck,
    IconChecklist,
    IconLanguage,
    IconLoader2,
    IconQuotes,
    IconTextSpellcheck,
    IconVocabulary,
    IconWorldQuestion,
    IconX
} from '@tabler/icons-react';
import { intlFormatDistanceWithOptions } from 'date-fns/fp';

export const sidebarWidth = 324;

export const mistakeSeverity = [
    { text: 'hint', color: '#003cbd' },
    { text: 'warning', color: '#ff6600' },
    { text: 'critical', color: '#c20000' }
];

export const BookmarkCategories = {
    ISSUE: 'issue',
    BROKEN_LINKS: 'broken_links',
    PDFS_FOUND: 'pdfs_found',
    PDFS_UPLOAD: 'pdfs_upload',
    SITE: 'site',
    SITE_ISSUE: 'site_issue',
    TOP_ISSUE: 'top_issue',
    SPELLCHECKER_MISTAKE: 'spellchecker_mistake',
    SPELLCHECKER_PAGE: 'spellchecker_page'
};

export const httpStatusCodes = {
    100: 'Continue',
    101: 'Switching Protocols',
    102: 'Processing',
    200: 'OK',
    201: 'Created',
    202: 'Accepted',
    203: 'Non-Authoritative Info',
    204: 'No Content',
    205: 'Reset Content',
    206: 'Partial Content',
    300: 'Multiple Choices',
    301: 'Moved Permanently',
    302: 'Found',
    303: 'See Other',
    304: 'Not Modified',
    305: 'Use Proxy',
    307: 'Temporary Redirect',
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Auth Required',
    408: 'Request Timeout',
    409: 'Conflict',
    410: 'Gone',
    411: 'Length Required',
    412: 'Precondition Failed',
    413: 'Payload Too Large',
    414: 'URI Too Long',
    415: 'Unsupported Media Type',
    416: 'Range Not Satisfiable',
    417: 'Expectation Failed',
    418: "I'm a teapot",
    422: 'Unprocessable Entity',
    425: 'Too Early',
    426: 'Upgrade Required',
    428: 'Precondition Required',
    429: 'Too Many Requests',
    431: 'Request Header Fields Too Large',
    451: 'Unavailable For Legal Reasons',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    505: 'HTTP Version Not Supported',
    511: 'Network Authentication Required',
    999: 'Request Denied'
};

export const spellCheckerCategories = {
    de: {
        0: 'Stil',
        1: 'Rechtschreibung',
        2: 'Bedeutung',
        3: 'Grammatik',
        4: 'Zeichensetzung',
        5: 'Sprache',
        6: 'Sonstiges'
    },
    en: {
        0: 'Style',
        1: 'Spelling',
        2: 'Meaning',
        3: 'Grammar',
        4: 'Punctuation',
        5: 'Language',
        6: 'Other'
    }
};

export const defaultReportSettings = {
    enableQueryParameters: false,
    targetLang: '',
    urlsToCheck: [],
    regex: [],
    actions: [],
    dictionary: {},
    lighthousePreferredUrls: [],
    lighthouseExcludedUrls: [],
    // ADMIN
    maxConcurrency: '',
    colorScheme: '',
    brokenLinksRequestDelay: ''
};

export const avatarColors = {
    1: '#ff991f',
    0: '#0052cc',
    me: '#19bb00'
};

export const boardColumns = {
    backlog: {
        titleKey: 'backlog',
        includeResolved: false
    },
    working: {
        titleKey: 'working',
        includeResolved: false
    },
    finished: {
        titleKey: 'resolved',
        includeResolved: true
    }
};

export const spellCheckerCategoryIcons = {
    0: IconAdjustmentsAlt,
    1: IconTextSpellcheck,
    2: IconArrowsDiff,
    3: IconVocabulary,
    4: IconQuotes,
    5: IconLanguage,
    6: IconWorldQuestion
};

const seriousAndError = {
    icon: IconX,
    props: {
        color: '#ff5e5f'
    }
};

const infoAndHint = {
    icon: intlFormatDistanceWithOptions,
    props: {
        color: '#41c7ff'
    }
};

export const RulesStatusIcons = {
    critical: {
        icon: CriticalIcon,
        props: {
            color: '#ffffff'
        }
    },
    serious: seriousAndError,
    error: seriousAndError,
    hint: infoAndHint,
    warning: {
        icon: WarningIcon,
        props: {
            color: '#fff000'
        }
    },
    passed: {
        icon: IconCheck,
        props: {
            color: '#15ff15'
        }
    },
    info: infoAndHint,
    checksrunning: {
        icon: IconLoader2,
        props: {
            color: '#0fb0ea',
            stroke: 2.1
        }
    },
    checkscompleted: {
        icon: IconChecklist,
        props: {
            color: '#15ff15',
            stroke: 2.1
        }
    }
};

export const defaultMyGoalsBoardFilters = {
    assignee: [],
    category: [],
    showOnlyMyIssues: false,
    searchText: ''
};
